import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

export const CARD_VALIDITY_YEARS = 2;
export const CARD_RENEWAL_FEE_GNF = 50000;

const renewWalletCardFn = httpsCallable(functions, 'renewWalletCard');

export async function renewWalletCard({
  paymentMethod = 'wallet',
  receiptUrl = null,
  payerReference = null
} = {}) {
  const { data } = await renewWalletCardFn({
    paymentMethod,
    receiptUrl,
    payerReference
  });
  return data;
}

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value?.toDate === 'function') return value.toDate();
  if (typeof value?.seconds === 'number') return new Date(value.seconds * 1000);
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function addYears(date, years) {
  const d = new Date(date.getTime());
  d.setFullYear(d.getFullYear() + years);
  return d;
}

/** Statut validité côté client (miroir de functions/cardValidity.js). */
export function getCardValidity(wallet) {
  const now = new Date();
  let issuedAt = toDate(wallet?.cardIssuedAt) || toDate(wallet?.createdAt) || now;
  let expiresAt = toDate(wallet?.cardExpiresAt);

  if (!expiresAt) {
    const tentative = addYears(issuedAt, CARD_VALIDITY_YEARS);
    if (tentative.getTime() < now.getTime()) {
      issuedAt = now;
      expiresAt = addYears(now, CARD_VALIDITY_YEARS);
    } else {
      expiresAt = tentative;
    }
  }

  const msLeft = expiresAt.getTime() - now.getTime();
  const active = msLeft > 0 && wallet?.cardStatus !== 'expired' && wallet?.cardStatus !== 'suspended';
  const daysLeft = Math.max(0, Math.ceil(msLeft / (24 * 60 * 60 * 1000)));

  return {
    issuedAt,
    expiresAt,
    active,
    expired: !active,
    daysLeft,
    renewalFeeGnf: CARD_RENEWAL_FEE_GNF,
    validityYears: CARD_VALIDITY_YEARS
  };
}

export function formatCardExpiry(date, locale = 'fr-FR') {
  if (!date) return '—';
  return new Date(date).toLocaleDateString(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}
